<template>
  <Modal v-model="abnormalStockingOfGoodsModal" :title="$t('key1001203')" class-name="commonModalStyles"
    width="700" :transfer="false" :mask-closable="false">
    <h2 class="mb12 font-size-14 color-333 font-weight-bold">{{ $t('key1001204') }}</h2>
    <div class="mb15" v-for="item in abnormalStockingOfGoodsData">
      <h3 class="color-333 font-size-14 mb3 ellipsis_1" :title="item.name"
        :class="system === 'distributor' ? 'distributorThemeColor' : 'themeColor'">
        {{ item.name }}
      </h3>
      <p v-html="item.specifications.join('<br/>')"></p>
    </div>
    <template #footer>
      <Button type="primary" @click="abnormalStockingOfGoodsBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import Mixin from '@/components/mixin/common_mixin';
import {isJSON, EventBus} from "@/utils/common";

export default {
  name: 'abnormalStockingOfGoodsModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      abnormalStockingOfGoodsModal: false,
      abnormalStockingOfGoodsData: []
    };
  },
  mounted() {
    EventBus.$on('initAbnormalStockingOfGoodsData', (data) => {
      this.abnormalStockingOfGoodsData = [];
      if (data) {
        if (isJSON(data)) {
          this.abnormalStockingOfGoodsData = JSON.parse(data);
        }
      }
      this.abnormalStockingOfGoodsModal = true;
    });
  },
  methods: {
    // 确定
    abnormalStockingOfGoodsBtn() {
      this.abnormalStockingOfGoodsModal = false;
    }
  },
  beforeDestroy() {
    EventBus.$off('initAbnormalStockingOfGoodsData');
  }
};
</script>

<style lang="less">

</style>